/**
 * Centralized CTA text and microcopy.
 * Site-wide pattern: primary CTA = "Run your first campaign",
 * secondary CTA = "Try a 3-minute conversation" (demo).
 */

import { WAITLIST_URL } from './links'

export const PRIMARY_CTA_TEXT = 'Run your first campaign'
export const SECONDARY_CTA_TEXT = 'Try a 3-minute conversation'
export const PRIMARY_CTA_MICROCOPY = 'Conversational surveys that surface the why your scoreboard misses.'

export const BETA_CTA_TEXT = 'Request beta access'
export const WAITLIST_CTA_TEXT = 'Join the waitlist'

export const FINAL_CTA_HEADLINE = 'Ready to know why?'

/** Callout CTA targets — both point to the external waitlist sign-up. */
export const EMBED_BETA_HREF = WAITLIST_URL
export const VOE_WAITLIST_HREF = WAITLIST_URL
